var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVaultDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.664 30.8058H2.33597C1.69964 30.8071 1.17146 30.3282 1.129 29.7111L0 13.2195L18.1035 11.4608L35 13.2195L33.8681 29.7111C33.8256 30.3269 33.2993 30.8055 32.664 30.8058Z",
    fill: "#A6AAB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0896 17.3639L30.8904 20.2539H4.10956L3.91036 17.3639C3.89861 17.2015 3.95709 17.0415 4.07138 16.9227C4.18593 16.8036 4.34615 16.7362 4.51384 16.7367H30.4861C30.6538 16.7362 30.814 16.8036 30.9286 16.9227C31.0429 17.0415 31.1014 17.2015 31.0896 17.3639Z",
    fill: "#A6AAB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8904 20.2539L30.649 23.7711L30.4439 26.7433C30.4218 27.051 30.158 27.2891 29.8405 27.2883H5.15952C4.84202 27.2891 4.57819 27.051 4.55603 26.7433L4.35095 23.7711L4.10956 20.2539L17.5 19.0814L30.8904 20.2539Z",
    fill: "#A6AAB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7809 20L30.5395 23.5172H4.24139L4 20H30.7809Z",
    fill: "#A6AAB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8793 12.6333H21.1206V17.9092C21.1206 19.8516 19.4998 21.4264 17.5 21.4264C15.5002 21.4264 13.8793 19.8516 13.8793 17.9092V12.6333Z",
    fill: "#888D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7069 16.7367C18.7069 17.3842 18.1664 17.9092 17.4999 17.9092C16.8334 17.9092 16.293 17.3842 16.293 16.7367C16.293 16.0892 16.8334 15.5642 17.4999 15.5642C18.1664 15.5642 18.7069 16.0892 18.7069 16.7367Z",
    fill: "#2C2F38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 19.6676C17.1667 19.6676 16.8965 19.4051 16.8965 19.0814V17.9092C16.8965 17.5854 17.1667 17.3229 17.5 17.3229C17.8332 17.3229 18.1035 17.5854 18.1035 17.9092V19.0814C18.1035 19.4051 17.8332 19.6676 17.5 19.6676Z",
    fill: "#2C2F38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2587 3.25391C8.11047 3.25391 7.36199 4.15662 6.03458 5.59888C5.14137 6.56592 5.66048 7.77368 5.4311 9.11607C5.36461 9.49713 4.22413 9.88986 4.22413 10.2883L3.01716 13.2195H1.22217e-06V9.70232C-0.00106689 7.99184 0.698014 6.35114 1.94317 5.14156C3.18833 3.93198 4.87728 3.25287 6.6378 3.25391H10.2587Z",
    fill: "#A6AAB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 9.70232V13.2195H31.9829L30.7759 10.2883C30.7759 9.88986 30.2389 9.49713 30.1724 9.11607C29.9431 7.77368 29.8587 6.56592 28.9655 5.59888C27.6381 4.15662 26.8896 3.25391 24.7413 3.25391H28.3622C30.123 3.25287 31.8117 3.93198 33.0569 5.14156C34.302 6.35114 35.0011 7.99184 35 9.70232Z",
    fill: "#A6AAB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9828 10.2883V13.2195H3.01715V10.2883C3.01768 9.89558 3.05186 9.50337 3.11969 9.11609L17.5 7.35736L31.8803 9.11609C31.9481 9.50337 31.9823 9.89558 31.9828 10.2883Z",
    fill: "#A6AAB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1422 5.59889L17.5 6.18487L4.85779 5.59889C6.23032 4.10345 8.19618 3.25003 10.2587 3.25392H24.7413C26.8038 3.25003 28.7697 4.10345 30.1422 5.59889Z",
    fill: "#A6AAB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8803 9.11607H3.11969C3.34212 7.80663 3.94508 6.58615 4.85778 5.59888H30.1422C31.0549 6.58615 31.6579 7.80663 31.8803 9.11607Z",
    fill: "#A6AAB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 13.2222C26.963 13.2222 34.5679 13.2222 35 13.2222",
    stroke: "#888D95"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 34,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaultDisabled);
export default __webpack_public_path__ + "static/media/vault-disabled.a57b82c2.svg";
export { ForwardRef as ReactComponent };